/*
 
Skórki Material

 
*/

import * as M from '@material-ui/core';

//import './theme.css'

// https://in-your-saas.github.io/material-ui-theme-editor/
// http://mcg.mbitson.com/#!?mcgpalette0=%2338920a&mcgpalette2=%2326a69a&themename=rez1
// https://www.materialpalette.com/blue/lime

//https://material-ui.com/style/color/

// material

// po wpisaniu do pliku:
//import themeProject from './cfg/theme.json';

const theme = M.createTheme({
  //  palette: appPalette,
  palette: {
    primary: { light: "rgb(232, 240, 254)", main: "#3a87ad", dark: "#005a7e" },
    secondary: { light: "rgb(232, 240, 254)", main: "#3a87ad", dark: "#005a7e" },
    error: { main: "rgb(255, 165, 0)" },
    text: { secondary: "#555" }
  },
  typography: {
    /*?? */
    //   useNextVariants: true, 
  },
  overrides: {
    MuiButton: {
      root:{
        textTransform: "none" as "none"
      }
    },
    MuiTableCell: {
      root: {
        padding: "14px 5px 14px 16px"
      },
      sizeSmall: {
        padding: "5px 12px 5px 12px"
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: "8px 14px",
        textAlign: "center",
        fontWeight: "normal"
      },
      multiline: {
        padding: "0px"
      }
    },
    MuiCheckbox: {
      root: {
        color: "#3a87ad",
      }
    },
    MuiFormControl: {
      marginNormal: {
        marginBottom: "10px"
      }
    }

  },
}
)

/*
const styleAppBar = (theme : any) => ({
  root: {
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  }
})  
  
styleAppBar,
*/

/*const styles = createStyles(appPalette);

export { styles,  appPalette }
*/
export default theme
